var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['Pin', _vm.colorClass, 'Pin--dragable'],attrs:{"draggable":"true"},on:{"dragstart":function($event){return _vm.dragPin({ pin: _vm.pin, dragType: 'options', event: $event })},"dragend":_vm.dragEnd}})
}
var staticRenderFns = []

export { render, staticRenderFns }